/*
/* https://developers.syte.ai/#6803267a-1817-4391-9b61-4a8819ca39dc
/* @returns {Object}
 */

const defaultData = {
    event: 'syteAPI',
    eventCategory: 'syte',
};

export default {
    cameraButtonImpression: () => window.dataLayer.push({
        ...defaultData,
        eventAction: 'cameraButtonImpression',
    }),
    cameraCropperFallBack: ({ moduleRef }) => window.dataLayer.push({
        ...defaultData,
        moduleRef,
        eventAction: 'cameraCropperFallBack',
    }),
    cameraShowLayout: ({ imageUrl }) => window.dataLayer.push({
        ...defaultData,
        imageUrl,
        eventAction: 'cameraShowLayout',
    }),
    cameraTourScreenClosed: () => window.dataLayer.push({
        ...defaultData,
        eventAction: 'cameraTourScreenClosed',
    }),
    cameraUploadClicked: ({ placement }) => window.dataLayer.push({
        ...defaultData,
        placement,
        eventAction: 'cameraUploadClicked',
    }),
    cameraUploadDone: () => window.dataLayer.push({
        ...defaultData,
        eventAction: 'cameraUploadDone',
    }),
    cropperRefine: ({ moduleRef }) => window.dataLayer.push({
        ...defaultData,
        moduleRef,
        eventAction: 'cropperRefine',
    }),
    discoveryButtonClick: ({ imageSrc, placement }) => window.dataLayer.push({
        ...defaultData,
        imageSrc,
        placement,
        eventAction: 'discoveryButtonClick',
    }),
    discoveryButtonImpression: ({ imageSrc, placement }) => window.dataLayer.push({
        ...defaultData,
        imageSrc,
        placement,
        eventAction: 'discoveryButtonImpression',
    }),
    inspirationGalleryClicked: ({ imgUrl, position, parentPage }) => window.dataLayer.push({
        ...defaultData,
        imgUrl,
        position,
        parentPage,
        eventAction: 'inspirationGalleryClicked',
    }),
    insposhopBoundClick: ({ imageUrl, label }) => window.dataLayer.push({
        ...defaultData,
        imageUrl,
        label,
        eventAction: 'insposhopBoundClick',
    }),
    insposhopGetBounds: ({ count }) => window.dataLayer.push({
        ...defaultData,
        count,
        eventAction: 'insposhopGetBounds',
    }),
    insposhopQuickView: ({ imageUrl, label }) => window.dataLayer.push({
        ...defaultData,
        imageUrl,
        label,
        eventAction: 'insposhopQuickView',
    }),
    insposhopShowModalLayout: ({ imageUrl }) => window.dataLayer.push({
        ...defaultData,
        imageUrl,
        eventAction: 'insposhopShowModalLayout',
    }),
    insposhopViewMoreClick: ({ imageUrl, label }) => window.dataLayer.push({
        ...defaultData,
        imageUrl,
        label,
        eventAction: 'insposhopViewMoreClick',
    }),
    modalShowOffers: ({ imageUrl, category, resultsCount, moduleRef }) => window.dataLayer.push({
        ...defaultData,
        category,
        imageUrl,
        moduleRef,
        resultsCount,
        eventAction: 'modalShowOffers',
    }),
    modelClosed: ({ imageUrl, closeTimeInApp, moduleRef }) => window.dataLayer.push({
        ...defaultData,
        imageUrl,
        closeTimeInApp,
        moduleRef,
        eventAction: 'modelClosed',
    }),
    productClicked: ({ moduleRef, sku, position }) => window.dataLayer.push({
        ...defaultData,
        moduleRef,
        position,
        sku,
        eventAction: 'productClicked',
    }),
    siShowLayout: () => window.dataLayer.push({
        ...defaultData,
        eventAction: 'siShowLayout',
    }),
    stlShowLayout: () => window.dataLayer.push({
        ...defaultData,
        eventAction: 'stlShowLayout',
    }),
    siShowModalLayout: ({ imageUrl }) => window.dataLayer.push({
        ...defaultData,
        imageUrl,
        eventAction: 'siShowModalLayout',
    }),
    tourStartButtonClicked: ({ type }) => window.dataLayer.push({
        ...defaultData,
        type,
        eventAction: 'tourStartButtonClicked',
    }),
};
